import { ResponsibilityModel } from './responsibility.model';
import { RoleModel } from './role.model';
export class RoleResponsibilityModel {
    constructor(data = {}) {
        this.id = data.id;
        this.responsibility = new ResponsibilityModel({ id: data.responsibility_id });
        this.role = new RoleModel({ id: data.additional_role_id });
    }
}
